<template>
  <div v-if="visible" class="ihu-modal-backdrop" @keyup.esc="close">
    <div class="ihu-modal-container" :class="'modal-' + size">
      <div class="close-modal" @click="close">
        <i class="ico-modal-close"></i>
      </div>
      <div class="ihu-modal">
        <div class="ihu-modal-content">
          <slot name="modal-header"></slot>
          <slot></slot>
          <slot name="modal-footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ihu-modal',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'default',
      },
    },
    mounted() {
      document.addEventListener('keydown', ({ key }) => {
        if (['Esc', 'Escape'].includes(key)) {
          this.close();
        }
      });
    },
    methods: {
      close(event) {
        if (event) event.preventDefault();
        if (event) event.stopPropagation();
        this.$emit('close');
      },
    },
  };
</script>

<style scoped lang="scss">
.ihu-modal-backdrop {
  @include themify {
    background-color: getColor('modal-background', 'ihu');
  }
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  overflow: auto;
  z-index: 10000;
  position: fixed;
  transition: opacity 0.3s ease;

  .ihu-modal-container {
    min-height: 436px;
    top: 114px;
    margin: 0 auto;
    position: relative;
  }
  .modal-sm {
    max-width: 300px;
  }
  .modal-default {
    min-width: 683px;
    width: fit-content;
  }
  .modal-lg {
    max-width: 800px;
  }
  .modal-xl {
    max-width: 1140px;
  }
  .ihu-modal {
    @include themify {
      background-color: getColor('modal-container-background', 'ihu');
    }
    position: relative;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    display: flex;
    box-shadow: 0px 16px 20px rgba(7, 9, 46, 0.13), 0px 3px 15px rgba(7, 9, 46, 0.1), 0px 0.997515px 8px rgba(7, 9, 46, 0.05);
    border-radius: 4px;
  }

  .close-modal {
    width: 18px;
    height: 18px;
    position: absolute;
    right: -30px;
    top: 6px;
    cursor: pointer;
    z-index: 1;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .ihu-modal-content {
    flex: 1;
    overflow: hidden;
  }
}
</style>
